import { SHOW_LOADER, HIDE_LOADER } from './types';

export function loading(isLoading: boolean) {
  return isLoading
    ? {
        type: SHOW_LOADER,
      }
    : {
        type: HIDE_LOADER,
      };
}
